import * as yup from 'yup'
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from "react";
import InputFecha from '../../../../components/inputs/yup/materialui/inputFecha';
import UseEndosoMasivo from '../hooks/useEndosoMasivo';
import InputSelect from '../../../../components/inputs/yup/materialui/inputSelect';
import { FiltroEndosoMasivo } from "../models/filtroEndosoMasivo";
import { Grid2 } from '@mui/material';
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import FilterListIcon from '@mui/icons-material/FilterList';
import ConfirmationModal from '../../../../components/ui/materialui/confirmationModal';
import Conversiones from '../../../../utils/conversiones';


interface IProps {
    onSubmit: (e: FiltroEndosoMasivo) => void
}

export const FormularioFiltroEndoso = ({onSubmit} : IProps) => {
    const { defaultValues, inversionistas, getInversionistas } = UseEndosoMasivo();

    const validationSchema: yup.ObjectSchema<FiltroEndosoMasivo> = yup.object().shape({
        fechaEndoso: yup.date().required("Fecha requerida")
            .test('isDateAfterToday', 'La fecha endoso no puede ser menor a la fecha actual', 
                function (value) {
                    return esFechaMenorActual(value);
                })
            .test('isDateInCurrentMonth', 'El mes de la fecha endoso no puede ser distinto al mes actual', 
                function (value) {
                    return esFechaEnMesActual(value);
                }),
        institucion: yup.string().required("Inversionista requerido")
    })

    const esFechaMenorActual = (inputFecha: Date | null | undefined) => {
        if (inputFecha == undefined) return false;

        const fechaActual = new Date();
        const fechaInputNormalizada = Conversiones.normalizarFecha(inputFecha);
        const fechaHoyNormalizada = Conversiones.normalizarFecha(fechaActual);
    
        return fechaInputNormalizada >= fechaHoyNormalizada
    };

    const esFechaEnMesActual = (inputFecha: Date | null | undefined) => {
        if (inputFecha == undefined) return false;

        const fechaInputNormalizada = Conversiones.normalizarFecha(inputFecha);

        const fechaActual = new Date();
        const anio = fechaActual.getFullYear();
        const mes = fechaActual.getMonth();
        const fechaMesSiguiente = new Date(anio, mes + 1, 1);

        return fechaInputNormalizada < fechaMesSiguiente;
    }

    const esFechaMismaHoy = (inputFecha: Date) : boolean => {
        if (inputFecha == undefined) return false;

        const fechaActual = new Date();

        const fechaInputNormalizada = Conversiones.normalizarFecha(inputFecha);
        const fechaHoyNormalizada = Conversiones.normalizarFecha(fechaActual);

        const esMismoDia = fechaInputNormalizada.getDate() === fechaHoyNormalizada.getDate();
        const esMismoMes = fechaInputNormalizada.getMonth() === fechaHoyNormalizada.getMonth();
        const esMismoAnio = fechaInputNormalizada.getFullYear() === fechaHoyNormalizada.getFullYear();

        return esMismoAnio && esMismoMes && esMismoDia;
    }

    useEffect(() => {
        getInversionistas();
    }, [])

    useEffect(() => {
        reset(defaultValues);
    }, [defaultValues]);

    const {
        register,
        formState: { errors, isDirty },
        handleSubmit,
        reset,
        setValue,
        clearErrors,
        control,
        watch,
    } = useForm<FiltroEndosoMasivo>({ resolver: yupResolver(validationSchema) })

    const fechaEndosoWatch = watch("fechaEndoso");

    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => {
        },
    });

    const checkOnSubmit = (e: FiltroEndosoMasivo) => {
        if (!esFechaMismaHoy(fechaEndosoWatch)){
            setModalConfirmacion({
                show: true,
                title: 'Confirmación',
                message: `Cada vez que se modifica la fecha endoso se debe volver a calcular la fecha de remesa ¿Desea continuar?`,
                metodo: () => {
                    onSubmit(e);
                },
            });
        }
        else{
            onSubmit(e);
        }
    }

    useEffect(() => {
        clearErrors();
    }, [fechaEndosoWatch])

    return(
        <>
            <ConfirmationModal
                onHide={() =>
                    setModalConfirmacion({ ...modalConfirmacion, show: false })
                }
                onConfirm={modalConfirmacion.metodo}
                show={modalConfirmacion.show}
                message={modalConfirmacion.message}
                title={modalConfirmacion.title}
            />
            <form onSubmit={handleSubmit(checkOnSubmit)}>
            <Grid2 container spacing={2} sx={{ marginTop: 1 }}>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputFecha
                        label="Fecha endoso"
                        name="fechaEndoso"
                        control={control}
                        fecha={defaultValues?.fechaEndoso ?? undefined}
                        error={errors.fechaEndoso}
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 9 }}>
                    <InputSelect
                        name="institucion"
                        control={control}
                        options={inversionistas}
                        label="Inversionista"
                        onChange={(value) => setValue("institucion", value?.toString() ?? "")}
                        error={errors.institucion}
                    />
                </Grid2>
            </Grid2>
            <Grid2 size={4} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                <MButton type="submit" variant="contained" color="primary" startIcon={<FilterListIcon />}>
                    Filtrar
                </MButton>
            </Grid2>
        </form>
        </>
    )
}